var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"product-column"},[_c('div',{staticClass:"product-column__inner",class:{ 'product-column__inner_sticky': !_vm.overflow }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }